import { useParams, Link } from 'react-router-dom';
import { useState, useMemo } from 'react';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';
import { articlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'news');

  const currentCategory = categories.find((c) => c.slug === activeCategory);
  const categoryArticles = useMemo(() => articlesByCategory(activeCategory), [activeCategory]);

  return (
    <Layout>
      <div className="pt-24 md:pt-28 pb-14 md:pb-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-[1280px] mx-auto">
          <Breadcrumb />

          <div className="mt-6 mb-10">
            <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              {currentCategory?.name || '分类'}
            </h1>
            <p className="text-sm text-foreground-500">{currentCategory?.description}</p>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveCategory(cat.slug)}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer"
                >
                  <div className="w-full h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2.5 py-0.5 rounded-full">
                        {article.tags[0]}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                    </div>
                    <h2 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-4xl text-foreground-300 mb-4 block"></i>
              <p className="text-foreground-500">该分类暂无内容</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}